"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_strategies_1 = require("../auth-strategies");
exports.default = {
    authStrategy: (0, auth_strategies_1.HwtStrategy)()
};
